import axios from 'axios';
import { message } from 'antd';
import { environments } from '../constants';

interface RequestHandlerParams {
  method: string;
  url_extension: string;
  params?: Record<string, any>;
  token?: string;
  org_check?: boolean;
}

export const requestHandler = async ({
  method,
  url_extension,
  params = {},
  token = '',
  org_check = false,
}: RequestHandlerParams) => {
  try {
    const url = org_check
      ? `${environments.REACT_APP_BASE_URL}/organisations/members/${url_extension}/organisations`
      : `${environments.REACT_APP_BASE_URL}/${url_extension}`;

    const response = await axios({
      method: method,
      url,
      data: JSON.stringify(params),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    });

    return response.data;
  } catch (error: any) {
    message.error(error?.message);
  }
};
